import React from "react";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import { getTestTypeDisplayLabel } from "./Helper";
import MRLCountryList from "./MRLCountryList";

import { hasPermission, permissions } from "../../../../../utils/Permissions";

import { ReactComponent as MRLIcon } from "../../../../../assets/images/product/MRLIcon.svg";
import { ReactComponent as QualitativeIcon } from "../../../../../assets/images/product/QualitativeIcon.svg";
import { ReactComponent as QuantitativeIcon } from "../../../../../assets/images/product/QuantitativeIcon.svg";
import { ReactComponent as RangeIcon } from "../../../../../assets/images/product/RangeIcon.svg";

import "../../../Product.css";
import "./SpecManager.css";
import "./SpecTable.css";

class SpecTable extends React.Component {
  static getFormattedSpec(specs, testType, test, countries_lst, prioritizeMRLWhenCountriesPresent = false) {
    let units = specs[2];
    let min = specs[0];
    let max = specs[1];
    const isMRLTest = Boolean(countries_lst) && hasPermission(permissions.global.specialPesticides);

    if (units === undefined) units = "";
    if (min === undefined) min = "";
    if (max === undefined) max = "";

    /** Empty specs for this test */
    if (!units && !min && !max && !isMRLTest) {
      return "-";
    }

    /** Global Spec Manager: when countries_list present, show only MRL (not min/max/unit) */
    if (prioritizeMRLWhenCountriesPresent && isMRLTest) {
      return (
        <MRLCountryList
          countriesData={countries_lst}
          editMode={false}
        />
      );
    }

    if (testType === "quantitative") {
      return `${max} ${units}`;
    }

    if (testType === "range") {
      return `${min} - ${max} ${units}`;
    }

    if (testType === "qualitative") {
      let value = specs[1];
      if (value === undefined) {
        value = "";
      }
      return `${min} ${value} ${units}`;
    }

    if (isMRLTest) {
      return (
        <MRLCountryList
          countriesData={countries_lst}
          editMode={false}
        />
      );
    }

    return `${min} ${max} ${units}`;
  }

  static getFormattedTestType(testType, test, countries_lst, prioritizeMRLWhenCountriesPresent = false) {
    const isMRLTest = countries_lst?.length > 0 && hasPermission(permissions.global.specialPesticides);

    /** Global Spec Manager: when countries_list present, show only MRL (not range/quantitative/qualitative) */
    if (prioritizeMRLWhenCountriesPresent && isMRLTest) {
      return (
        <div className="SpecTable__TestType">
          <MRLIcon />
          <span>MRL</span>
        </div>
      );
    }

    const typeLabel = getTestTypeDisplayLabel(testType)
      || (testType ? testType.charAt(0).toUpperCase() + testType.substring(1) : "");

    if (testType === "quantitative") {
      return (
        <div className="SpecTable__TestType">
          <QuantitativeIcon />
          <span>{typeLabel}</span>
        </div>
      );
    }

    if (testType === "qualitative") {
      return (
        <div className="SpecTable__TestType">
          <QualitativeIcon />
          <span>{typeLabel}</span>
        </div>
      );
    }

    if (testType === "range") {
      return (
        <div className="SpecTable__TestType">
          <RangeIcon />
          <span>{typeLabel}</span>
        </div>
      );
    }

    if (isMRLTest) {
      return (
        <div className="SpecTable__TestType">
          <MRLIcon />
          <span>MRL</span>
        </div>
      );
    }

    return <span>{testType || "-"}</span>;
  }

  renderTests() {
    const { dataOfSpecEditing, prioritizeMRLWhenCountriesPresent = false } = this.props;

    return dataOfSpecEditing.map((item, index) => (
      <tr key={index}>
        <td className="SpecTable__TableContentTest">
          {item.test}
        </td>

        <td className="SpecTable__TableContentType">
          {SpecTable.getFormattedTestType(
            item.test_type,
            item.test,
            item.countries_lst,
            prioritizeMRLWhenCountriesPresent,
          )}
        </td>

        <td className="SpecTable__TableContentTestValue">
          {SpecTable.getFormattedSpec(
            item.specs,
            item.test_type,
            item.test,
            item.countries_lst,
            prioritizeMRLWhenCountriesPresent,
          )}
        </td>
      </tr>
    ));
  }

  render() {
    return (
      <StyledScrollbar
        disableTrackYWidthCompensation
        disableTracksWidthCompensation
        className="SpecTable__Scrollbar"
        id="specManagerSpecTableScrollBarProduct"
      >
        <table className="specTable">
          <thead>
            <tr>
              <th className="specManagerEditSpecTh1">Test</th>
              <th className="specManagerEditSpecTh2">Test Type</th>
              <th className="specManagerEditSpecTh3">Specs</th>
            </tr>
          </thead>
          <tbody>{this.renderTests()}</tbody>
        </table>
      </StyledScrollbar>
    );
  }
}

export default SpecTable;
